import { render, staticRenderFns } from "./edit.component.vue?vue&type=template&id=8c1ddc12"
import script from "./edit.component.vue?vue&type=script&lang=js"
export * from "./edit.component.vue?vue&type=script&lang=js"
import style0 from "./edit.component.vue?vue&type=style&index=0&id=8c1ddc12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports